import { createAction } from 'redux-actions';
import {
  SERVICE_LIST_FETCH,
  SERVICE_LIST_SUCCESS,
  SERVICE_LIST_FAILURE,
  DELETE_SERVICE_FETCH,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-SERVICES--->>>
export const serviceListFetch = createAction(SERVICE_LIST_FETCH);
export const serviceListSuccess = createAction(SERVICE_LIST_SUCCESS);
export const serviceListFailure = createAction(SERVICE_LIST_FAILURE);

export const fetchServices = () => async dispatch => {
  dispatch(serviceListFetch());
  try {
    const res = await api.get('service');
    dispatch(serviceListSuccess(res.data));
  } catch (error) {
    dispatch(serviceListFailure(error));
  }
};

//<<<---DELETE-SERVICE--->>>
export const deleteServiceFetch = createAction(DELETE_SERVICE_FETCH);
export const deleteServiceSuccess = createAction(DELETE_SERVICE_SUCCESS);
export const deleteServiceFailure = createAction(DELETE_SERVICE_FAILURE);

export const deleteService = (id, lang, callback) => async dispatch => {
  dispatch(deleteServiceFetch());
  try {
    const res = await api.post(`service/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteServiceSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteServiceFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ServiceList/actions.js